import * as React from 'react'
import { type IconProps } from './types'
/**
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHlsZT0iYmFja2dyb3VuZDojZmZmIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE4Ljg4MzkgOC4xMTYxMkMxOS4zNzIgOC42MDQyNyAxOS4zNzIgOS4zOTU3MyAxOC44ODM5IDkuODgzODhMMTIuODgzOSAxNS44ODM5QzEyLjM5NTcgMTYuMzcyIDExLjYwNDMgMTYuMzcyIDExLjExNjEgMTUuODgzOUMxMC42MjggMTUuMzk1NyAxMC42MjggMTQuNjA0MyAxMS4xMTYxIDE0LjExNjFMMTcuMTE2MSA4LjExNjEyQzE3LjYwNDMgNy42Mjc5NiAxOC4zOTU3IDcuNjI3OTYgMTguODgzOSA4LjExNjEyWiIgZmlsbD0iYmxhY2siLz4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTUuMTE2MTIgOC4xMTYxMkM1LjYwNDI3IDcuNjI3OTYgNi4zOTU3MyA3LjYyNzk2IDYuODgzODggOC4xMTYxMkwxMi44ODM5IDE0LjExNjFDMTMuMzcyIDE0LjYwNDMgMTMuMzcyIDE1LjM5NTcgMTIuODgzOSAxNS44ODM5QzEyLjM5NTcgMTYuMzcyIDExLjYwNDMgMTYuMzcyIDExLjExNjEgMTUuODgzOUw1LjExNjEyIDkuODgzODhDNC42Mjc5NiA5LjM5NTczIDQuNjI3OTYgOC42MDQyNyA1LjExNjEyIDguMTE2MTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4=)
 */
export const DownIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 15, ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.8839 8.11612C19.372 8.60427 19.372 9.39573 18.8839 9.88388L12.8839 15.8839C12.3957 16.372 11.6043 16.372 11.1161 15.8839C10.628 15.3957 10.628 14.6043 11.1161 14.1161L17.1161 8.11612C17.6043 7.62796 18.3957 7.62796 18.8839 8.11612Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.11612 8.11612C5.60427 7.62796 6.39573 7.62796 6.88388 8.11612L12.8839 14.1161C13.372 14.6043 13.372 15.3957 12.8839 15.8839C12.3957 16.372 11.6043 16.372 11.1161 15.8839L5.11612 9.88388C4.62796 9.39573 4.62796 8.60427 5.11612 8.11612Z"
          fill={color}
        />
      </svg>
    )
  },
)
